import React from "react";
import type { IconProps } from "./types";

const LogoutIcon: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logout-clip)">
      <path
        d="M13.415 6.586l-1.94-1.94a.5.5 0 00-.707.708l1.94 1.94c.057.058.107.123.15.194-.008 0-.014-.004-.022-.004L4.995 7.5a.5.5 0 100 1l7.839-.016c.014 0 .025-.007.039-.008-.045.085-.101.163-.167.231l-1.94 1.94a.5.5 0 10.707.707l1.94-1.94a2 2 0 000-2.828h.002z"
        fill={color}
      />
      <path
        d="M5.5 13h-1A1.5 1.5 0 013 11.5v-7A1.5 1.5 0 014.5 3h1a.5.5 0 100-1h-1A2.503 2.503 0 002 4.5v7A2.503 2.503 0 004.5 14h1a.5.5 0 000-1z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="logout-clip">
        <path fill="#fff" transform="translate(2 2)" d="M0 0H12V12H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default LogoutIcon;
